import type { ImgHTMLAttributes } from "react"

interface ResponsiveImageProps extends Omit<
  ImgHTMLAttributes<HTMLImageElement>,
  "alt" | "className" | "decoding" | "height" | "loading" | "src" | "width"
> {
  alt: string
  avifSrc?: string
  className?: string
  decoding?: "async" | "auto" | "sync"
  height: number
  loading?: "eager" | "lazy"
  pictureClassName?: string
  src: string
  width: number
}

export function ResponsiveImage({
  alt,
  avifSrc,
  className,
  decoding = "async",
  height,
  loading = "lazy",
  pictureClassName,
  src,
  width,
  ...imageProps
}: ResponsiveImageProps) {
  const image = (
    <img
      {...imageProps}
      src={src}
      alt={alt}
      className={className}
      width={width}
      height={height}
      loading={loading}
      decoding={decoding}
    />
  )

  if (!avifSrc && !pictureClassName) {
    return image
  }

  return (
    <picture className={pictureClassName}>
      {avifSrc ? <source srcSet={avifSrc} type="image/avif" /> : null}
      {image}
    </picture>
  )
}
